import { useQuery } from '@tanstack/react-query';
import { ZONE_BY_ID_QUERY_KEY } from 'constants/queryKeys';
import ZoneService from 'services/ZoneService';

/**
 * Fetches the Zone document a paddock plan is built from. A created Input
 * embeds a projection of this record, so the zone must be loaded before a
 * plan can be written with the correct zoneName and geoData.
 * @param zoneId - The zone to fetch, typically `paddock.zoneId`
 */
export const useFetchZoneById = (zoneId: string | null | undefined) =>
  useQuery({
    queryKey: [ZONE_BY_ID_QUERY_KEY, zoneId],
    queryFn: async () => ZoneService.GetById(zoneId as string),
    enabled: !!zoneId,
    staleTime: 1000 * 60 * 5,
  });

export default useFetchZoneById;
